import { render, staticRenderFns } from "./TestimonialsVideo.vue?vue&type=template&id=1cff5b27&scoped=true"
import script from "./TestimonialsVideo.vue?vue&type=script&lang=js"
export * from "./TestimonialsVideo.vue?vue&type=script&lang=js"
import style0 from "./TestimonialsVideo.vue?vue&type=style&index=0&id=1cff5b27&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cff5b27",
  null
  
)

export default component.exports